import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.qs-checks-benutzer-zugriff';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksQsChecksBenutzerZugriffEffects {

    QsChecksBenutzerZugriff$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_QS_CHECKS_BENUTZER_ZUGRIFF),
        mergeMap((x: ac.GetQsChecksBenutzerZugriffAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getQsChecksBenutzerZugriff().pipe(
                map((result: any) => {
                    return new ac.GetQsChecksBenutzerZugriffErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetQsChecksBenutzerZugriffFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.QsChecksQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.QsChecksQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.QsChecksQueryService);
        }
        return this.service;
    }
}
